import { useContext } from 'react'
import { connect } from 'react-redux';
import MapContext from "../Map/MapContext";
import {masquerCarre, afficherCarre} from '../librairies'

function GestionAffichageCouches({ listecontenu }) {

    const { map } = useContext(MapContext);

    if (!map) return null;

    let carresNonAffiches = []

    map.getLayers().forEach(element => {

        listecontenu.forEach(legende => {
            if (element.getProperties().type === legende.type) {
                element.setOpacity(legende.afficher ? 1 : 0);
            }
            if(!legende.afficher){
                 carresNonAffiches.push(legende.type)
            }
        })


        if(element.getProperties().type === 'CARREE'){

            if(carresNonAffiches.includes('DEVELOPPEMENTECONOMIQUE')){
                masquerCarre(element,'violet')
            }else{
                afficherCarre(element, 'violet', "rgb(146, 122, 183)", "rgba(146, 122, 183, 0.2)")
            }

            if(carresNonAffiches.includes('DEVELOPPEMENTURBAIN')){
                masquerCarre(element,'orange')
            }else{
                afficherCarre(element, 'orange', "rgb(248, 153, 79)", "rgba(248, 153, 79, 0.2)")
            }

            if(carresNonAffiches.includes('PLAISANCEETBALNEAIRE')){
                masquerCarre(element,'jaune')
            }else{
                afficherCarre(element, 'jaune', "rgb(251, 225, 73)","rgba(251, 225, 73, 0.2)")
            }

            if(carresNonAffiches.includes("INFRASTRUCTURE")){
                masquerCarre(element,'rouge')
            }else{
                afficherCarre(element, 'rouge', "rgb(214,137,135)","rgba(214,137,135,0.2)")
            }
            
        }
    });

    return (
        null
    )
}

function mapStateToProps(state) {
    return {
        listecontenu: JSON.parse(state.contenu)
    }
}

export default connect(mapStateToProps, null)(GestionAffichageCouches);